import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row position-relative" }
const _hoisted_2 = { class: "col-md-12 mb-2 mt-2" }
const _hoisted_3 = {
  class: "tab-pane fade in active show",
  id: "members",
  style: {"overflow-x":"auto"}
}
const _hoisted_4 = {
  key: 0,
  class: "datatables table table-striped table-bordered"
}
const _hoisted_5 = { class: "thead-dark" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { ref: "qrList" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "col-md-12 text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_element_per_page = _resolveComponent("element-per-page")!
  const _component_path_image = _resolveComponent("path-image")!
  const _component_member_route = _resolveComponent("member-route")!
  const _component_btn_default = _resolveComponent("btn-default")!
  const _component_btn_delete = _resolveComponent("btn-delete")!
  const _component_not_found = _resolveComponent("not-found")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRequestParticipations)
      ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_element_per_page),
        (_ctx.participationsList && _ctx.participationsList?.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
              _createElementVNode("thead", _hoisted_5, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("tables.members.path_image")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("tables.members.matricule")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("tables.members.name")), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("tables.members.cin")), 1),
                  (
                                _ctx.hasPermission('delete_member') ||
                                _ctx.hasPermission('edit_member') ||
                                _ctx.hasPermission('fiche_member')
                            )
                    ? (_openBlock(), _createElementBlock("th", _hoisted_6, _toDisplayString(_ctx.i18n.t("tables.action")), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tbody", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participationsList, (participation, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `${participation?.member_info?.id}-${index}`
                  }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_path_image, {
                        class: "img-table",
                        path_image: participation?.member_info?.path_image ??
                                    `${participation?.member_info?.gender == 0
                                        ? 'female.png'
                                        : 'male.png'
                                    }`
                                    
                      }, null, 8, ["path_image"])
                    ]),
                    _createElementVNode("td", null, [
                      (_ctx.hasPermission('fiche_member'))
                        ? (_openBlock(), _createBlock(_component_member_route, {
                            key: 0,
                            memberUUID: participation?.member_info?.uuid,
                            matricule: participation?.member_info?.matricule
                          }, null, 8, ["memberUUID", "matricule"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(participation?.member_info?.matricule), 1))
                    ]),
                    _createElementVNode("td", null, _toDisplayString(participation?.member_info?.name ?? ""), 1),
                    _createElementVNode("td", null, _toDisplayString(participation?.member_info?.cin ?? ""), 1),
                    _createElementVNode("td", null, [
                      (_ctx.hasPermission('fiche_member') && participation?.member_info?.uuid)
                        ? (_openBlock(), _createBlock(_component_btn_default, {
                            key: 0,
                            btnClass: `btn btn-show m-1`,
                            onDefault: ($event: any) => (_ctx.redirectTo({ name: 'fiche', params: { clubUUID: _ctx.clubUUID, memberUUID: participation?.member_info?.uuid } })),
                            icon: "eye",
                            tooltip: _ctx.i18n.t('button.fiche')
                          }, null, 8, ["onDefault", "tooltip"]))
                        : _createCommentVNode("", true),
                      (_ctx.hasPermission('delete_member_subscription'))
                        ? (_openBlock(), _createBlock(_component_btn_delete, {
                            key: 1,
                            onDelete: ($event: any) => (_ctx.deleteSubscriptionMember(participation?.id))
                          }, null, 8, ["onDelete"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ], 512)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_not_found, {
                text: _ctx.i18n.t('message.data_not_found.title'),
                icon: "warning"
              }, null, 8, ["text"])
            ]))
      ])
    ]),
    (_ctx.hasPermission('new_subscriptions') && _ctx.active_subscription?.pack
            ?.max_members &&
            _ctx.active_subscription?.pack
                ?.max_members > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_router_link, {
            to: {
                name: 'subscription-participations',
                params: {
                    clubUUID: _ctx.clubUUID,
                    memberSubscriptionId:
                        _ctx.active_subscription?.id,
                },
                query: {
                    memberUUID: _ctx.member_UUID
                }
            },
            class: "btn btn-money"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "users",
                size: "lg",
                class: "link-icon"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.i18n.t(
                        'views.clients.subscription_participations.add_participation',
                    )), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ]))
}